
import React from "react";
import { IMember } from "../../../services";
import * as ReactRouterDom from "react-router-dom";
import ManageTournaments from "./ManageTournaments";
import YourTournament from "./your_tournament/YourTournament";

export interface TournamentsProps {
    profile: IMember;
}

function Tournaments(props: TournamentsProps) {

    const { profile } = props;

    return (<ReactRouterDom.Routes>
        <ReactRouterDom.Route path="/" element={<ManageTournaments profile={profile} />} />
        <ReactRouterDom.Route path="/:id" element={<YourTournament profile={profile} />} />
    </ReactRouterDom.Routes>);

}

export default Tournaments;
